import { __decorate, __metadata } from 'tslib';
import { Input, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { BrMaskerModule } from 'br-mask';
import { TooltipModule } from 'ng2-tooltip-directive';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';

let UiCRechargePhoneResume = class UiCRechargePhoneResume {
    constructor() {
    }
    ngOnInit() { }
};
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCRechargePhoneResume.prototype, "resumeRechargeData", void 0);
UiCRechargePhoneResume = __decorate([
    Component({
        selector: 'ui-c-recharge-phone-resume',
        template: "<div class=\"recharge-phone-resume\">\n  <ion-row class=\"container-info mt-2\">\n    <ion-col size=\"12\">\n      <ion-item lines=\"none\">\n        <ion-label>{{'RECHARGE_PHONE.LABELS.NUMBER' | wlpTranslate}} <span> ({{resumeRechargeData?.ddd}}) - {{resumeRechargeData?.phone}}</span> </ion-label>\n      </ion-item>\n      <ion-item lines=\"none\">\n        <ion-label>{{'RECHARGE_PHONE.LABELS.OPERATOR' | wlpTranslate}} <span> {{resumeRechargeData?.operatorDescription}} </span></ion-label>\n      </ion-item>\n    </ion-col>\n  </ion-row>\n\n\n\n  <ion-row class=\"recharge-value ion-justify-content-center ion-text-center\">\n    <ion-col size=\"12\">\n      <h3>{{'RECHARGE_PHONE.LABELS.VALUE' | wlpTranslate}} </h3>\n      <h5>{{resumeRechargeData?.value.value | currency: 'BRL'}}</h5>\n    </ion-col>\n  </ion-row>\n</div>",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCRechargePhoneResume);

let UiCRechargePhoneResumeModule = class UiCRechargePhoneResumeModule {
};
UiCRechargePhoneResumeModule = __decorate([
    NgModule({
        declarations: [UiCRechargePhoneResume],
        imports: [
            CommonModule,
            IonicModule,
            ReactiveFormsModule,
            TooltipModule,
            BrMaskerModule,
            NgxMaskIonicModule,
            UiBsTranslateModule,
        ],
        exports: [UiCRechargePhoneResume]
    })
], UiCRechargePhoneResumeModule);

export { UiCRechargePhoneResume, UiCRechargePhoneResumeModule };
//# sourceMappingURL=wlp-ui-c-recharge-phone-resume.js.map
